import { useRef } from 'react';
import { useEffectOnce } from './useEffectOnce';

export const useUnmount = (fn: () => unknown): void => {
  const fnRef = useRef(fn);

  // update the ref each render so if it change the newest callback will be invoked
  fnRef.current = fn;

  useEffectOnce(() => (): void => {
    fnRef.current();
  });
};
